import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { QuestionInputFilter } from "domain/models/nimberforms-input-filters";
import { Logger } from "infra/logger/logger";
import questionRepository from "infra/repositories/question-repository";
import { FormQuestionPayload, FormQuestionUpdatePayload } from "presentation/components/NimberForms/FormEdit";

export const useGetQuestionByFilter = (filter: QuestionInputFilter, options?: { enabled?: boolean }) => {
    const logger = Logger.getInstance();
    return useQuery({
        // include the filter in the queryKey so a new query is created when the filter changes
        queryKey: ["FormsQuestion", filter],
        queryFn: async () => {
            try {
                const result = await questionRepository.getAll(filter);
                return result;
            } catch (error: any) {
                if (error instanceof AxiosError) {
                    logger.error(
                        error.response?.data.metadata.errors[0],
                        error.response?.data.metadata
                    );
                    throw new Error(error.response?.data.metadata.errors);
                }
                throw error;
            }
        },
        // only run when we have a valid formTemplateId
        enabled: options?.enabled ?? true
    });
}
export const useCreateQuestionMutation = () => {
    const logger = Logger.getInstance();
    const queryQuestion = useQueryClient();

    return useMutation({
        mutationFn: async (questions: FormQuestionPayload[]) => {
            const result = await questionRepository.create(questions);
            return result;
        },
        onSuccess: () => {
            queryQuestion.invalidateQueries({queryKey: ["FormsQuestion", {}]});
        },
        onError: (error) => {
            if (error instanceof AxiosError) {
                console.log("raw error:", error)
                if (error.response?.data?.metadata?.errors) {
                    const errors = error.response.data.metadata.errors;
                    logger.error(errors[0], error.response?.data.metadata);
                    console.log("error axios",errors[0]);
                    //Cria um objeto de erro com o array de erros como propriedade
                    const customError = new Error("Erro ao criar questions");
                    (customError as any).errors = errors; // Adiciona o array de erros ao objeto de erro
                    throw customError;
                } else {
                    throw new Error("Erro desconhecido da API");
                }
                }else {
                    logger.error("Erro desconhecido", error);
                    throw error;
                }
        }
    });
}

export const useUpdateQuestionMutation = () => {
    const logger = Logger.getInstance();
    const queryQuestion = useQueryClient();

    return useMutation({
        mutationFn: async (questions: FormQuestionUpdatePayload[]) => {
            const result = await questionRepository.update(questions);
            return result;
        },
        onSuccess: () => {
            queryQuestion.invalidateQueries({queryKey: ["FormsQuestion", {}]});
        },
        onError: (error) => {
            if (error instanceof AxiosError) {
                console.log("raw error:", error)
                if (error.response?.data?.metadata?.errors) {
                    const errors = error.response.data.metadata.errors;
                    logger.error(errors[0], error.response?.data.metadata);
                    console.log("error axios",errors[0]);
                    //Cria um objeto de erro com o array de erros como propriedade
                    const customError = new Error("Erro ao atualizar questions");
                    (customError as any).errors = errors; // Adiciona o array de erros ao objeto de erro
                    throw customError;
                } else {
                    throw new Error("Erro desconhecido da API");
                }
                }else {
                    logger.error("Erro desconhecido", error);
                    throw error;
                }
        }
    });
}

export const useDeleteQuestionMutation = () => {
    const logger = Logger.getInstance();
    const queryQuestion = useQueryClient();

    return useMutation({
        mutationFn: async (id: string) => {
            const result = await questionRepository.delete(id);
            return result;
        },
        onSuccess: () => {
            queryQuestion.invalidateQueries({queryKey: ["FormsQuestion", {}]});
        },
        onError: (error) => {
            if (error instanceof AxiosError) {
                console.log("raw error:", error)
                if (error.response?.data?.metadata?.errors) {
                    const errors = error.response.data.metadata.errors;
                    logger.error(errors[0], error.response?.data.metadata);
                    console.log("error axios",errors[0]);
                    //Cria um objeto de erro com o array de erros como propriedade
                    const customError = new Error("Erro ao apagar questions");
                    (customError as any).errors = errors; // Adiciona o array de erros ao objeto de erro
                    throw customError;
                } else {
                    throw new Error("Erro desconhecido da API");
                }
                }else {
                    logger.error("Erro desconhecido", error);
                    throw error;
                }
        }
    });
}